import React, { useState, useEffect, useRef, forwardRef } from 'react';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';

import ProjectsPage from './ProjectsPage';

import NawigacjaGora from '../Nav';
import AboutUpSection from '../Inne-Strony/UpSection';
import OpadajacaStrona from '../OpadajacaStrona';
import Zaslona from '../Zanimowane/Zaslona';
import Footer from '../Inne-Strony/Footer';

export default function ProjectsPageWrapper() {

    const [menuState, setMenuState] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 500);
    const handleMenu = () => {
        setMenuState(!menuState);
        console.log(menuState);
    };

    const { ref, inView } = useInView();
    const pageVariants = {
        initial: {
            opacity: 1,
        },
        in: {
            opacity: 1,
        },
        out: {
            opacity: 1,
        },
    };

    const pageTransition = {
        type: 'tween',
        ease: 'anticipate',
        duration: 1.0,
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 500);
        };
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <motion.div
            initial="initial"
            animate="in"
            exit="out"
            variants={pageVariants}
            transition={pageTransition}>

            <OpadajacaStrona isVisible={menuState} />
            <NawigacjaGora stanMenu={menuState} zmienMenu={handleMenu} czyCzarnyTekst={inView ? false : true} />
            <Zaslona />

            <div ref={ref} className='h-screen w-full bg-[#061e3d]'>
                <AboutUpSection czyZanimowane={false} inView={inView}
                    przycisk={true} obrazek={"fala1.jpg"} tytul={"Projects"} text={"Projects that I have worked on"} />
            </div>
            <div className='relative top-72 overflow-hidden'>
                <ProjectsPage />
            </div>
            <Footer />
        </motion.div>
    )
}